<template>
  <div style="width: 250px" class="d-flex align-center">
    <SysGrupoAutocomplete
      v-model="GRUPO_COMPRA"
      label="Grupo de compras"
      hide-details
      outlined
      dense
      cor_loading="red"
      :disabled="data_table_departamentos_carregando_dados"
      append-icon="mdi-chevron-down"
    />
  </div>
</template>

<script>
import SysGrupoAutocomplete from "@/components/utils/crud/SysGrupoAutocomplete";
import {data_table_departamentos_carregando_dados} from "@/components/utils/dataTable/sysDataTableDepartamentos/CarregandoDados.js";

export default {
  name: "GrupoCompra",
  mixins: [data_table_departamentos_carregando_dados],
  components: {
    SysGrupoAutocomplete
  },
  computed: {
    GRUPO_COMPRA: {
      get() {
        return this.$store.getters["usuario/getGrupoCompras"];
      },
      set(valor) {
        this.$store.dispatch('usuario/setGrupoCompras', valor);
      }
    }
  }
}
</script>

<style scoped>

</style>
